export const platformRoutes = [
  {
    path: "/app",
    label: "Command Center",
    section: "Project",
    meta: "Platform overview",
    title: "Command Center",
    description: "Overview across intake, review, docs, and vendors.",
    enabled: true,
  },
  {
    path: "/app/compliance-checker",
    label: "Compliance Checker",
    section: "Project",
    meta: "AI + local IFRA review",
    title: "Compliance Checker",
    description: "Extract and validate formulas.",
    enabled: true,
  },
  {
    path: "/app/perfume-dashboard",
    label: "Formula Library",
    section: "Project",
    meta: "Saved IFRA runs",
    title: "Formula Library",
    description: "Saved formulas and IFRA results.",
    enabled: true,
  },
  {
    path: "/app/labeling",
    label: "Labeling",
    section: "Project",
    meta: "EU + US label drafts",
    title: "Labeling",
    description: "Generate EU and US compliant labels for any product.",
    enabled: true,
  },
  {
    path: "/app/document-submission",
    label: "Document Intake",
    section: "Project",
    meta: "Upload and triage",
    title: "Document Intake",
    description: "Upload and route supplier files.",
    enabled: false,
    disabledReason: "Document intake is not active in this release.",
  },
  {
    path: "/app/document-repository",
    label: "Repository",
    section: "Project",
    meta: "Certificates and MSDS",
    title: "Document Repository",
    description: "Stored compliance documents.",
    enabled: false,
    disabledReason: "Document repository is not active in this release.",
  },
  {
    path: "/app/vendor-management",
    label: "Vendors",
    section: "Operations",
    meta: "Documents and renewals",
    title: "Vendor Network",
    description: "Supplier status and renewals.",
    enabled: false,
    disabledReason: "Vendor management is not active in this release.",
  },
  {
    path: "/app/compliance-tracker",
    label: "Tracker",
    section: "Operations",
    meta: "Status across markets",
    title: "Product Tracker",
    description: "Market readiness by region.",
    enabled: true,
  },
  {
    path: "/app/compliance-automation",
    label: "Automation",
    section: "Operations",
    meta: "Workflow signals",
    title: "Automation Hub",
    description: "Job status and execution.",
    enabled: false,
    disabledReason: "Worker execution not built",
  },
  {
    path: "/app/workflow-automation",
    label: "Workflow",
    section: "Operations",
    meta: "Task routing",
    title: "Workflow Control",
    description: "Routing and escalations.",
    enabled: false,
    disabledReason: "Approvals and reminders not built",
  },
  {
    path: "/app/regulatory-intelligence",
    label: "Intelligence",
    section: "Watch",
    meta: "Policy updates",
    title: "Regulatory Intelligence",
    description: "Policy updates by market.",
    enabled: true,
  },
];

export const findRouteMeta = (pathname) => {
  const exact = platformRoutes.find((route) => pathname === route.path);
  if (exact) return exact;
  const prefixed = platformRoutes.find((route) => pathname.startsWith(`${route.path}/`));
  if (prefixed) return prefixed;
  return platformRoutes.find((route) => route.path === "/app");
};
